import { IconAlertTriangle } from '@tabler/icons-react'
import { Stack, Typography } from '@mui/material'
import { Radar } from './Radar'
import { FeatureIcon, featureIconSizeMap } from '../FeatureIcon'

export const EmptyStateRadar = ({
  title,
  description,
  featureIconSize = 'small',
}: {
  title: string
  description: string
  featureIconSize?: 'small' | 'medium' | 'large'
}) => {
  return (
    <Stack
      sx={{
        position: 'relative',
        justifyContent: 'center',
        flexGrow: 1,
        height: 1,
        minHeight: 200,
        mask: 'linear-gradient(0deg, transparent 5%, black 45%, black 85%, transparent 95%) no-repeat',
        WebkitMask:
          'linear-gradient(0deg, transparent 5%, black 45%, black 85%, transparent 95%) no-repeat',
      }}
    >
      <Stack
        sx={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          width: '100%',
          transform: 'translate(-50%, -50%)',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Radar baseRadius={featureIconSizeMap[featureIconSize].iconCircleRadius}>
          <FeatureIcon size={featureIconSize} icon={<IconAlertTriangle />} />
        </Radar>

        <Stack sx={{ position: 'absolute', top: '100%', pt: 1 }}>
          <Stack sx={{ alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: 'text.primary' }}>
              {title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {description}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}
